// extracted by mini-css-extract-plugin
export var cardHeader = "_t5-0";
export var reorderHandle = "_t5-3";
export var titleArea = "_t5-1";
export var titleAreaWithHandle = "_t5-2";